import styled from 'styled-components';

export const AutocompleteWrapper = styled.div`
  position: relative;
  input {
    width: 100%;
  }
  ul {
    &.active {
      border-width: 0 1px 1px 1px;
      z-index: 10;
    }
  }
`;
